export const NAVIGATION_PATHS = {
  DASHBOARD: "/dashboard",
  NEW_CASE: "/new-case",
  CASES: "/cases",
  // Provider portal (MDRS-157) — the records provider's fulfilment surface.
  PROVIDER_DASHBOARD: "/provider/dashboard",
  PROVIDER_REQUESTS: "/provider/requests",
  PROVIDER_ACCOUNT: "/provider/account",
  REPORT_STUDIO: "/report-studio",
  REPORT_TEMPLATES: "/report-templates",
  INVOICE_STUDIO: "/invoice-studio",
  USER_MANAGEMENT: "/user-management",
  ACCESS_LOGS: "/access-logs",
  ACCESS_CONTROL: "/access-control",
  ACCESS_CONFIG: "/access-config",
  USERS_ADMIN: "/users-admin",
  BOOKING_APPROVALS: "/booking-approvals",
};
